import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiMenuItemDTO,
  MenuItemDTO,
} from "@lib/strapi/dtos/components/menu/menuItem.dto";
import { LinkService } from "@lib/strapi/services/components/shared/link.service";
import { getImageProps, ImageProps } from "@lib/image";

export class MenuItemService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiMenuItemDTO,
  ): Promise<MenuItemDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new MenuItemDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.link = await LinkService.fromStrapi(locale, strapiData.link);
    dto.image = getImageProps(strapiData.image);
    return dto;
  }
}
